<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      ВСН 012-88 (Часть 2)<br>
      Форма № 2.14а
    </div>
    <n-items v-if="project">
      <n-input title="Министерство" v-bind="$form.input('ministry')" :text="!editable" />
      <n-input title="Объединение трест" v-bind="$form.input('cooperation')" :text="!editable" />
      <n-input title="СМУ, СУ, ПМК, КТП и дп." v-bind="$form.input('smuSuPmkKtp')" :text="!editable" />
      <n-input title="Участок" v-bind="$form.input('place')" :text="!editable" />
      <n-input title="Форма" v-bind="$form.input('form')" :text="!editable" />
      <n-input title="Основание" v-bind="$form.input('base')" :text="!editable" />
      <n-input title="Строительство" v-bind="$form.input('building')" :text="!editable" />
      <n-input title="Объект" v-bind="$form.input('obj')" :text="!editable" />
    </n-items>
    <div class="chapter-title">ЖУРНАЛ ИЗОЛЯЦИОННО-УКЛАДОЧНЫХ РАБОТ И РЕМОНТА ИЗОЛЯЦИИ</div>
    <n-items v-if="project">
      <div style="width: 100%; text-align: center; margin-top: -20px">
        от км <n-input inline v-bind="$form.input('fromKm')" :text="!editable" style="width: 80px" /> ПК <n-input inline v-bind="$form.input('fromPk')" :text="!editable" style="width: 80px" />
      </div>
      <div style="width: 100%; text-align: center; margin-top: -20px">
        до км <n-input inline v-bind="$form.input('untilKm')" :text="!editable" style="width: 80px" /> ПК <n-input inline v-bind="$form.input('untilPk')" :text="!editable" style="width: 80px" />
      </div>
      <n-input title="Начало работ" v-bind="$form.input('startedAt')" :text="!editable" />
      <n-input title="Окончание работ" v-bind="$form.input('endedAt')" :text="!editable" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
